import * as React from "react";
import {
  Box,
  Slide,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function UnsubscribePopup({ open, handleClose, action }) {
  const { t } = useTranslation("common");
  return (
    <Box color="default">
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => handleClose(false)}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: {
            backgroundColor: "var(--paper-color, #1E1E1E)",
            boxShadow: "none",
            color: "var(--text-primary, #fff)",
            borderRadius: 16,
            padding: 16,
          },
        }}
      >
        <DialogTitle sx={{ color: "var(--text-primary, #fff)", textAlign: "center" }}>
          {action === "Unsubscribe" ? t("unsubscribePopup.text1") : null}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            color="secondary"
            align="center"
            id="alert-dialog-slide-description"
          >
            {t("unsubscribePopup.text2")} {t("unsubscribePopup.text3")}?.
          </DialogContentText>
          <DialogContentText
            mt={2}
            color="secondary"
            variant="body2"
            align="center"
            id="alert-dialog-slide-description"
          >
            {t("unsubscribePopup.text4")}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Button
            sx={{ width: "50%" }}
            variant="outlined"
            color="secondary"
            onClick={() => handleClose(false)}
          >
            {t("unsubscribePopup.button1")}
          </Button>
          <Button
            sx={{ width: "50%" }}
            variant="outlined"
            color="secondary"
            onClick={() => handleClose(true)}
          >
            {t("unsubscribePopup.button2")}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
